module.exports = __webpack_public_path__ + "img/icTag.05da09cc.svg";